module.exports = __webpack_public_path__ + "img/每天只做今日任务.5145ad40.png";